import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";

const TITLE = "Dzikir Pagi - Benteng Muslim - Dzikir Pagi dan Petang";
const DESCRIPTION = "Dzikir pagi dari Benteng Muslim. Tekan lingkaran untuk mencatat setiap tasbih dengan penghitung otomatis yang menghitung jumlah yang diminta dan tersisa untuk setiap dzikir pagi.";
const KEYWORDS = "Dzikir pagi, Benteng Muslim, Dzikir pagi dan petang, Dzikir Islami, Tasbih pagi";
const OG_URL = "https://do-calculate.com/calculator/id/athkar-alsabah/";

const athkarList = [
    {
        key: "ayat_kursi",
        title: "Ayat Kursi",
        text: "A'uudzu billaahi minasy syaithoonir rojiim\nAllaahu laa ilaaha illaa huwal hayyul qoyyuum, laa ta'khudzuhuu sinatuw wa laa nauum, lahuu maa fis samaawaati wa maa fil ardhi, man dzalladzii yasyfa'u 'indahuu illaa bi idznih, ya'lamu maa baina aidiihim wa maa kholfahum, wa laa yuhiithuuna bi syai'im min 'ilmihii illaa bimaa syaa-a, wasi'a kursiyyuhus samaawaati wal ardha, wa laa ya-uuduhuu hifzhuhumaa, wa huwal 'aliyyul 'azhiim",
        fadl: "Barangsiapa membacanya ketika pagi, ia akan dilindungi dari jin hingga petang",
        count: 1,
    },
    {
        key: "ikhlas",
        title: "Surah Al-Ikhlas",
        text: "Bismillaahir rahmaanir rahiim\nQul huwallaahu ahad, Allaahush shamad, lam yalid wa lam yuulad, wa lam yakullahuu kufuwan ahad",
        fadl: "Barangsiapa membacanya ketika pagi dan petang, maka dia akan dicukupkan dari segala sesuatu",
        count: 3,
    },
    {
        key: "falaq",
        title: "Surah Al-Falaq",
        text: "Bismillaahir rahmaanir rahiim\nQul a'uudzu birobbil falaq, min syarri maa khalaq, wa min syarri ghoosiqin idzaa waqob, wa min syarrin naffaatsaati fil 'uqod, wa min syarri haasidin idzaa hasad",
        fadl: "",
        count: 3,
    },
    {
        key: "nas",
        title: "Surah An-Nas",
        text: "Bismillaahir rahmaanir rahiim\nQul a'uudzu birobbin naas, malikin naas, ilaahin naas, min syarril waswaasil khonnaas, alladzii yuwaswisu fii shuduurin naas, minal jinnati wan naas",
        fadl: "",
        count: 3,
    },
    {
        key: "duaa_sabah",
        title: "Doa Pagi",
        text: "Ashbahnaa wa ashbahal mulku lillaahi wal hamdulillaah, laa ilaaha illallaahu wahdahu laa syariika lahu, lahul mulku wa lahul hamdu wa huwa 'alaa kulli syai-in qodiir, robbi as-aluka khoiro maa fii haadzal yaumi wa khoiro maa ba'dah, wa a'uudzu bika min syarri maa fii haadzal yaumi wa syarri maa ba'dah, robbi a'uudzu bika minal kasali wa suu-il kibar, robbi a'uudzu bika min 'adzaabin fin naari wa 'adzaabin fil qobri",
        fadl: "",
        count: 1,
    },
    {
        key: "sayyid_istighfar",
        title: "Sayyidul Istighfar (Penghulu Istighfar)",
        text: "Allaahumma anta robbii laa ilaaha illaa anta, kholaqtanii wa ana 'abduka, wa ana 'alaa 'ahdika wa wa'dika mastatho'tu, a'uudzu bika min syarri maa shona'tu, abuu-u laka bini'matika 'alayya wa abuu-u bidzanbii faghfir lii fa-innahu laa yaghfirudz dzunuuba illaa anta",
        fadl: "Barangsiapa mengucapkannya dengan penuh keyakinan di waktu pagi lalu meninggal di hari itu, ia akan masuk surga",
        count: 1,
    },
    {
        key: "rida",
        title: "Ridha kepada Allah sebagai Rabb",
        text: "Rodhiitu billaahi robbaa, wa bil islaami diinaa, wa bi muhammadin shollallaahu 'alayhi wa sallama nabiyyaa",
        fadl: "Barangsiapa mengucapkannya ketika pagi dan petang, maka hak bagi Allah untuk meridhainya pada hari kiamat",
        count: 3,
    },
    {
        key: "shahada_tawheed",
        title: "Kesaksian Tauhid",
        text: "Allaahumma innii ashbahtu usy-hiduka wa usy-hidu hamalata 'arsyika wa malaa-ikataka wa jamii'a kholqika annaka antallaahu laa ilaaha illaa anta wahdaka laa syariika laka wa anna muhammadan 'abduka wa rosuuluka",
        fadl: "Barangsiapa mengucapkannya, Allah akan membebaskannya dari api neraka",
        count: 4,
    },
    {
        key: "shukr_nima",
        title: "Syukur atas Nikmat",
        text: "Allaahumma maa ashbaha bii min ni'matin au bi ahadin min kholqika faminka wahdaka laa syariika laka falakal hamdu wa lakasy syukru",
        fadl: "Barangsiapa mengucapkannya di waktu pagi, maka ia telah menunaikan syukur hari itu",
        count: 1,
    },
    {
        key: "hasbiyallah",
        title: "Hasbiyallah (Cukuplah Allah bagiku)",
        text: "Hasbiyallaahu laa ilaaha illaa huwa 'alayhi tawakkaltu wa huwa robbul 'arsyil 'azhiim",
        fadl: "Barangsiapa mengucapkannya, maka Allah akan mencukupinya dari urusan dunia dan akhirat yang mencemaskannya",
        count: 7,
    },
    {
        key: "bismillah_hifz",
        title: "Bismillah untuk Penjagaan",
        text: "Bismillaahilladzii laa yadurru ma'asmihii syai-un fil ardhi wa laa fis samaa-i wa huwas samii'ul 'aliim",
        fadl: "Tidak akan membahayakannya sesuatu apapun hingga petang",
        count: 3,
    },
    {
        key: "hayat_mamat",
        title: "Doa Kehidupan dan Kematian",
        text: "Allaahumma bika ashbahnaa wa bika amsainaa, wa bika nahyaa wa bika namuutu wa ilaikan nusyuur",
        fadl: "",
        count: 1,
    },
    {
        key: "fitrat_islam",
        title: "Fitrah Islam",
        text: "Ashbahnaa 'alaa fitratil islaami, wa 'alaa kalimatil ikhlaashi, wa 'alaa diini nabiyyinaa muhammadin shollallaahu 'alayhi wa sallama, wa 'alaa millati abiinaa ibroohiima haniifam muslimaw wa maa kaana minal musyrikiin",
        fadl: "",
        count: 1,
    },
    {
        key: "subhan_full",
        title: "Subhanallah wa Bihamdih (Lengkap)",
        text: "Subhaanallaahi wa bihamdihi 'adada kholqihi, wa ridhoo nafsihi, wa zinata 'arsyihi, wa midaada kalimaatihi",
        fadl: "",
        count: 3,
    },
    {
        key: "afiya",
        title: "Doa Keselamatan ('Afiyah)",
        text: "Allaahumma 'aafinii fii badanii, allaahumma 'aafinii fii sam'ii, allaahumma 'aafinii fii bashorii, laa ilaaha illaa anta",
        fadl: "",
        count: 3,
    },
    {
        key: "kufr_faqr",
        title: "Memohon Perlindungan dari Kekufuran dan Kemiskinan",
        text: "Allaahumma innii a'uudzu bika minal kufri, wal faqri, wa a'uudzu bika min 'adzaabil qobri, laa ilaaha illaa anta",
        fadl: "",
        count: 3,
    },
    {
        key: "afw_afiya",
        title: "Doa Maaf dan Keselamatan ('Afiyah)",
        text: "Allaahumma innii as-alukal 'afwa wal 'aafiyata fid dunyaa wal aakhiroh, allaahumma innii as-alukal 'afwa wal 'aafiyata fii diinii wa dunyaaya wa ahlii wa maalii, allaahummas tur 'awrootii wa aamin row'aati, allaahumma khfazhnii min baini yadayya wa min kholfii wa 'an yamiinii wa 'an syimaalii wa min fauqii, wa a'uudzu bi'azhamatika an ughtaala min tahtii",
        fadl: "",
        count: 1,
    },
    {
        key: "ya_hayy",
        title: "Ya Hayyu Ya Qoyyuum (Wahai Yang Maha Hidup, Maha Mandiri)",
        text: "Yaa hayyu yaa qoyyuum birohmatika as taghiits, ashlih lii sya'nii kullahu, wa laa takilnii ilaa nafsii thorfata 'ainin",
        fadl: "",
        count: 3,
    },
    {
        key: "khayr_yawm",
        title: "Doa Kebaikan Hari Ini",
        text: "Ashbahnaa wa ashbahal mulku lillaahi robbil 'aalamiin, allaahumma innii as-aluka khoiro haadzal yaumi fathahu wa nashrohu wa nuurohu wa barokatahu wa hudaahu, wa a'uudzu bika min syarri maa fiihi wa syarri maa ba'dah",
        fadl: "",
        count: 1,
    },
    {
        key: "shar_nafs",
        title: "Memohon Perlindungan dari Keburukan Diri",
        text: "Allaahumma 'aalimal ghoibi wasy syahaadati faathiros samaawaati wal ardhi robba kulli syai-in wa maliikah, asyhadu an laa ilaaha illaa anta, a'uudzu bika min syarri nafsii wa min syarris syaithooni wa syirkihi, wa an aqtarifa 'alaa nafsii suu-an au ajurrahu ilaa muslim",
        fadl: "",
        count: 1,
    },
    {
        key: "kalimat_allah",
        title: "Memohon Perlindungan dengan Kalimat-Kalimat Allah",
        text: "A'uudzu bikalimaatillaahit taammaati min syarri maa khalaq",
        fadl: "",
        count: 3,
    },
    {
        key: "salawat",
        title: "Shalawat kepada Nabi ﷺ",
        text: "Allaahumma sholli wa sallim wa baarik 'alaa nabiyyinaa muhammad",
        fadl: "Barangsiapa bershalawat kepadanya ketika pagi dan petang, ia akan mendapatkan syafaatnya di hari kiamat",
        count: 10,
    },
    {
        key: "shirk",
        title: "Memohon Perlindungan dari Kesyirikan",
        text: "Allaahumma innaa na'uudzu bika min an nusyrika bika syai-an na'lamuhu wa nastaghfiruka limaa laa na'lamuhu",
        fadl: "",
        count: 3,
    },
    {
        key: "hamm_huzn",
        title: "Memohon Perlindungan dari Kedukaan dan Kesedihan",
        text: "Allaahumma innii a'uudzu bika minal hammi wal hazani, wa a'uudzu bika minal 'ajzi wal kasali, wa a'uudzu bika minal jubni wal bukhli, wa a'uudzu bika min gholabatid daini wa qohrir rijaal",
        fadl: "",
        count: 3,
    },
    {
        key: "istighfar_azeem",
        title: "Istighfar Agung",
        text: "Astaghfirullaahal 'azhiimalladzii laa ilaaha illaa huwal hayyul qoyyuumu wa atuubu ilaih",
        fadl: "",
        count: 3,
    },
    {
        key: "hamd_jalal",
        title: "Pujian atas Keagungan",
        text: "Yaa robbi lakal hamdu kamaa yanbaghii lijalaali wajhika wa li'azhiimi sulthoonika",
        fadl: "",
        count: 3,
    },
    {
        key: "ilm_rizq",
        title: "Memohon Ilmu dan Rezeki",
        text: "Allaahumma innii as-aluka 'ilman naafi'an, wa rizqon thoyyibaa, wa 'amalan mutaqobbalaa",
        fadl: "",
        count: 1,
    },
    {
        key: "tawakkul",
        title: "Tawakkal dan Daya Upaya",
        text: "Allaahumma anta robbii laa ilaaha illaa anta, 'alaika tawakkaltu wa anta robbul 'arsyil 'azhiim, maa syaa-allahu kaana wa maa lam yasya' lam yakun, wa laa hawla wa laa quwwata illaa billaahil 'aliyyil 'azhiim",
        fadl: "",
        count: 1,
    },
    {
        key: "la_ilaha_100",
        title: "Laa Ilaaha Illallah (100x)",
        text: "Laa ilaaha illallaahu wahdahu laa syariika lahu, lahul mulku wa lahul hamdu wa huwa 'alaa kulli syai-in qodiir",
        fadl: "Itu sama dengan memerdekakan sepuluh budak, ditulis baginya seratus kebaikan, dan dihapus darinya seratus keburukan",
        count: 100,
    },
    {
        key: "subhan_100",
        title: "Subhanallah wa Bihamdih (100x)",
        text: "Subhaanallaahi wa bihamdihi",
        fadl: "Dihapuskan kesalahan-kesalahannya meskipun sebanyak buih di lautan",
        count: 100,
    },
    {
        key: "istighfar_100",
        title: "Istighfar (100x)",
        text: "Astaghfirullaaha wa atuubu ilaih",
        fadl: "Seratus kebaikan, dihapus seratus keburukan, dan menjadi benteng dari setan hingga petang",
        count: 100,
    },
];

const playDoneSound = () => {
    try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        [523, 659, 784].forEach((freq, i) => {
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            oscillator.type = "sine";
            oscillator.frequency.value = freq;
            const t = audioContext.currentTime + i * 0.13;
            gainNode.gain.setValueAtTime(0.2, t);
            gainNode.gain.exponentialRampToValueAtTime(0.001, t + 0.3);
            oscillator.start(t);
            oscillator.stop(t + 0.3);
        });
    } catch (error) {
        console.log("Audio play failed:", error);
    }
};

const AthkarAlSabah = () => {
    const initialCounts = {};
    athkarList.forEach((a) => { initialCounts[a.key] = 0; });

    const [counts, setCounts] = useState(initialCounts);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");

    const handleIncrement = (key, target) => {
        setCounts((prev) => {
            const newCount = (prev[key] || 0) + 1;
            if (newCount === target) {
                playDoneSound();
                setSnackbarMessage(`Selamat! Anda telah menyelesaikan dzikir ini ✅`);
                setSnackbarOpen(true);
                setTimeout(() => setSnackbarOpen(false), 4000);
            }
            return { ...prev, [key]: newCount };
        });
    };

    const handleDecrement = (key) => {
        setCounts((prev) => ({
            ...prev,
            [key]: Math.max((prev[key] || 0) - 1, 0),
        }));
    };

    const handleReset = (key) => {
        setCounts((prev) => ({ ...prev, [key]: 0 }));
    };

    return (
        <div >
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />

            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <h1 style={{ fontSize: "17px", margin: 0 }}>
                            Dzikir Pagi - Benteng Muslim
                        </h1>
                    </div>

                    <div
                        className="border border-light shadow-lg p-4 rounded"
                        style={{
                            backgroundColor: "#f8f9fa",
                            borderRadius: "10px",
                            boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
                        }}
                    >
                        <div className="row">
                            <div>
                                <p>
                                    Dzikir pagi adalah doa dan dzikir yang bersumber dari Benteng Muslim, diucapkan pada
                                    waktu pagi sebagai perlindungan dan benteng untuk harimu. Tekan lingkaran untuk mencatat setiap
                                    tasbih, dan gunakan tombol "Kurangi" untuk mengoreksi jumlah atau "Reset" untuk memulai dari awal.{" "}
                                    <b>
                                        Penghitung menunjukkan jumlah yang diminta dan tersisa untuk setiap dzikir, dan saat selesai akan mengeluarkan bunyi peringatan.
                                    </b>
                                </p>
                                <p>
                                    Anda juga dapat menggunakan tombol-tombol untuk melacak kemajuan Anda dalam setiap dzikir, yang membantu Anda untuk konsisten dengan dzikir harian dengan mudah dan ringan. Semoga Allah membalas Anda dengan kebaikan atas semangat Anda dalam mengingat Allah di pagi hari, dan menjadikannya benteng bagi Anda dari segala keburukan.
                                </p>
                            </div>
                        </div>

                        {athkarList.map((item) => {
                            const current = counts[item.key] || 0;
                            const isDone = current >= item.count;
                            const remaining = Math.max(item.count - current, 0);

                            return (
                                <div className="row" key={item.key} style={{ paddingBottom: "15px" }}>
                                    <div className="col calculatorStyle">
                                        {/* Card Header */}
                                        <div className="p-3 mb-2 bg-success text-white text-center">
                                            <h2 style={{ fontSize: "22px", marginBottom: item.fadl ? "6px" : "0" }}>
                                                {item.title}
                                            </h2>
                                            {item.fadl && (
                                                <p style={{ fontSize: "13px", color: "#d4edda", margin: 0 }}>
                                                    ✦ {item.fadl}
                                                </p>
                                            )}
                                        </div>

                                        <hr />

                                        <div dir="ltr">
                                            {/* Dhikr Text */}
                                            <p style={{ fontSize: "18px", lineHeight: "2", textAlign: "center", color: "#333", whiteSpace: "pre-line" }}>
                                                {item.text}
                                            </p>

                                            <hr />

                                            {/* Circle Counter */}
                                            <div className="text-center my-4">
                                                <div
                                                    style={{
                                                        background: isDone
                                                            ? "linear-gradient(135deg, #d4edda 0%, #a8d5b5 100%)"
                                                            : "linear-gradient(135deg, #ffffff 0%, #e0f7fa 100%)",
                                                        color: isDone ? "#198754" : "#4caf50",
                                                        borderRadius: "50%",
                                                        width: "300px",
                                                        height: "300px",
                                                        fontSize: "70px",
                                                        fontWeight: "bold",
                                                        margin: "0 auto",
                                                        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                        cursor: isDone ? "default" : "pointer",
                                                        userSelect: "none",
                                                        alignItems: "center",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        flexDirection: "column",
                                                    }}
                                                    onClick={() => !isDone && handleIncrement(item.key, item.count)}
                                                >
                                                    {current}
                                                    {isDone && (
                                                        <span style={{ fontSize: "20px", display: "block", marginTop: "8px" }}>✅</span>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Target & Remaining */}
                                            <div className="text-center" style={{ fontSize: "16px", color: "#198754", marginBottom: "12px" }}>
                                                Diminta: <strong>{item.count}</strong> &nbsp;|&nbsp; Tersisa: <strong>{remaining}</strong>
                                            </div>

                                            <br />

                                            {/* Action Buttons */}
                                            <div className="text-center mt-2">
                                                <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
                                                    <button
                                                        className="text-white px-4 py-2"
                                                        style={{
                                                            background: "linear-gradient(135deg, #f44336 0%, #e57373 100%)",
                                                            borderRadius: "20px",
                                                            fontSize: "16px",
                                                            fontWeight: "bold",
                                                            border: "none",
                                                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                            transition: "background 0.3s",
                                                            padding: "15px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => handleDecrement(item.key)}
                                                    >
                                                        Kurangi
                                                    </button>
                                                    <button
                                                        className="text-white px-4 py-2"
                                                        style={{
                                                            background: "linear-gradient(135deg, #2196f3 0%, #64b5f6 100%)",
                                                            borderRadius: "20px",
                                                            fontSize: "16px",
                                                            fontWeight: "bold",
                                                            border: "none",
                                                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                            transition: "background 0.3s",
                                                            padding: "15px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => handleReset(item.key)}
                                                    >
                                                        Reset
                                                    </button>
                                                </div>

                                                {isDone && (
                                                    <div
                                                        className="mt-3"
                                                        style={{
                                                            backgroundColor: "#d4edda",
                                                            color: "#155724",
                                                            borderRadius: "10px",
                                                            padding: "10px",
                                                            fontSize: "15px",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        ✅ Anda telah menyelesaikan dzikir ini, semoga Allah membalas Anda dengan kebaikan
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>

                <div className="col">
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>

            {/* Snackbar */}
            {snackbarOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: "20px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#198754",
                        color: "white",
                        padding: "14px 24px",
                        borderRadius: "8px",
                        fontSize: "15px",
                        fontWeight: "bold",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                        zIndex: 9999,
                    }}
                >
                    {snackbarMessage}
                </div>
            )}
        </div>
    );
};

export default AthkarAlSabah;